module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-num",
    attrs: {
      "id": "C1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "chap-title"
  }, [_vm._v("THE EARLY YEARS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Joe Biden is a proud son of Scranton, Pennsylvania. His family roots run deep there. But the roots he set for himself are firmly placed in Delaware.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His family moved to the state in pursuit of a job in 1953, the year Joe turned eleven."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN11",
      "id": "FT11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" His father, Joe Sr., had lived in Wilmington before he married Joe’s mom, Jean. The Bidens had a traditional household, with Joe working many different jobs as the primary breadwinner. During tough times in Scranton, Joe Sr. got a job as a boiler cleaner for a heating, ventilation and air conditioning company in Delaware, driving back and forth across the 140-mile stretch, a long and draining commute."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN12",
      "id": "FT12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eventually, the family packed up and moved to Delaware. They chose the Claymont area at the northern tip of the state, close to the Pennsylvania border. Brookview Apartments was located off Philadelphia Pike; the new two-story home was white with columns out front. Across the road stood a former mansion known as Archmere, now a school, which drew Joe like a magnet and would eventually play a role in his children’s lives."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN13",
      "id": "FT13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Joe started in the third grade in Delaware—he was actually a repeat because he had missed a lot of that school year in Scranton after his tonsils and adenoids had been removed. His school was Holy Rosary in Claymont, along Philadelphia Pike."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN14",
      "id": "FT14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" The school at Holy Rosary, founded around 1950, was built and supported by the greatest generation, those who had served in World War II and created thriving communities in the postwar era “so that we might be who we are today,” Bishop William Koenig remarked at the parish’s one hundredth anniversary celebration in 2022. (The event was attended by parishioner Anne Carney and her son Governor John Carney, who also attended Holy Rosary School.)"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN15",
      "id": "FT15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" The school was originally built with eight classrooms to hold 150 students in order to accommodate the growing parish population: “At the present time it is of vital importance to care for the many elementary grade children who have come into the Claymont parish in the past few years,” children such as the Bidens, a reporter noted."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN16",
      "id": "FT16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The nuns at Holy Rosary instructed students in the scholastic arts of history, math, geography, reading and writing. The Catholic doctrine also brought with it instruction in the fundamental principles of “decency, fair play, and virtue,” Joe later recalled. “You didn’t give your life, but it was noble to help a lady across a street. It was noble to offer a hand up to somebody who had less. It was noble to step in when the bully was picking on somebody. It was noble to intervene.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN17",
      "id": "FT17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Those moral lessons were ingrained in the children’s heads. At Holy Rosary, Joe once took the blame for another student’s eraser toss. He stayed after school in detention. “When you intervene, you have to stand up and take the consequences,” Joe later remembered. But the students had an affection for their teacher-disciplinarians, piling the nuns’ desks high with soaps as Christmas gifts."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN18",
      "id": "FT18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Biden was also cognizant of his important role as a big brother to his sister, Valerie. She tagged along with him, and he stood up for her, including her in everything. “Wherever he went I was there and the guys just accepted me,” she recalled. “He was a wonderful, wonderful brother, and what he did through all my years growing up was, he always watched out for me, but he never acted like he was doing me a favor. On the other hand, I always watched out for him.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN19",
      "id": "FT19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two years later, in 1955, the Bidens bought a new home in the community of Mayfield. They were the fourth family to move into the brand-new development, devoid of trees and shade. Joe Sr. was a bit of an anomaly in the neighborhood, which was mostly populated by young professionals—chemists, accountants and lawyers—who primarily worked at DuPont, then a driving economic powerhouse. For those workers, DuPont in Delaware was a symbol of job security, and Mayfield was a “way station for these young men working their way up the corporate ladder,” Joe wrote."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN20",
      "id": "FT20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" For the Bidens, Mayfield was also a temporary stopping point, but it was a move up from the apartment complex."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN21",
      "id": "FT21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Bidens had to drive farther to attend Sunday mass, as Mayfield was mostly Protestant, and Joe transferred to St. Helena’s, just a few blocks away."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN22",
      "id": "FT22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" It was there that Biden was ridiculed by a nun for his stuttering, and it was there that Jean Finnegan Biden showed her son what advocacy meant—and the important role of being a parent. Uncowed by the nuns’ habits and position in her church, Jean spoke with fire to defend her son. “If you every speak to my son like that again, I’ll come back and rip that bonnet off your head. Do you understand me?” she told the nun."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN23",
      "id": "FT23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Holy Rosary and Saint Helena’s both continued until 2008, when they merged into a single school with just over 280 students in grades pre-K through eight. Declining student populations forced the diocese’s hand, but leaders were determined to preserve the best parts of the schools’ identities and create new traditions. The new school was named Pope John Paul II, honoring one of the longest-serving pontiffs in Roman Catholic history."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN24",
      "id": "FT24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" “The decline came as part of an entire shift in how people saw education for their children. People are now consumers of an educational product, with a more vested interest in how that school should work, where as a generation or two ago, you simply just went to your neighborhood for your child’s source of education,” reflected the new school’s principal."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN25",
      "id": "FT25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Claymont had undergone many changes over the centuries. Its origins were agricultural, as many early Delaware communities were. It slowly transformed into suburbia and a relaxation area for many Philadelphia families with wealth to spare. In the early 1900s, it became a community of industrial workers, many of whom worked at the steel plants."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN26",
      "id": "FT26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Claymont would continue to evolve as its Catholic schools had changed. The steel mill was shuttered in 2013, with 375 workers losing their jobs."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN27",
      "id": "FT27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Brookview Apartments, seen as a model neighborhood in the 1950s, became known for its crime rather than its community. By 2005, it was primarily a low-income housing complex and was demolished to make room for the Darley Green townhome development. Some local leaders thought prospective buyers were crazy, but the project persisted."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN28",
      "id": "FT28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" “We removed the single biggest stigma in Claymont when we tore down the Brookview Apartments,” said Don Robitzer, an officer with the original developer. “They were in disrepair, unoccupied and a portion was burnt down.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN29",
      "id": "FT29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d977fc0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 78
// module chunks = 0